import type React from 'react';
import type { FC } from 'react';

import { ButtonIconAction } from 'components/button/ButtonIconAction';
import { Typography } from 'enable-ui';

import { ReactComponent as BackIcon } from 'assets/icons/back.svg';

import type { ButtonIconActionItem } from 'components/button/types';

import { COLOR } from 'constants/color';

export const HeaderDetailPage: FC<{
  title: React.ReactNode | string;
  showAction?: boolean;
  actions?: ButtonIconActionItem[];
  goBack: () => void;
  style?: React.CSSProperties;
}> = ({ title, showAction, actions, goBack, style }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 40,
        ...style,
      }}
    >
      <section style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <BackIcon style={{ cursor: 'pointer' }} onClick={goBack} />
        <Typography variant="h3" weight={500} color={COLOR.surfaceNeutralBold['neutral-11']}>
          {title}
        </Typography>
      </section>

      {showAction && <ButtonIconAction actions={actions as ButtonIconActionItem[]} />}
    </div>
  );
};
